import {Link} from 'react-router-dom/cjs/react-router-dom.min';
import Section from '../Section';
import SectionContents from '../SectionContents';
import SectionContentsBody from '../SectionContentsBody';
import SectionContentsCta from '../SectionContentsCta';

import Card from './Card';
import {Row} from 'reactstrap';

import {useViewport} from 'contexts/ViewportContext';
import {VIEWPORT_WIDTHS} from 'configs';

import local from './Stakeholder.module.scss';

export default function LandingStakeholder() {
  const {size} = useViewport();
  const isMobile = VIEWPORT_WIDTHS[size] < VIEWPORT_WIDTHS['md'];
  return (
    <Section removePad="bottom" mobilePad="top">
      <SectionContents sizes={{xs: [12, 12], lg: [9, 3]}}>
        <div className={local['section-header']}>
          <SectionContentsBody
            label="Trusted by Industry, Government, and Regulators"
            title="Stakeholder Support"
            description={
              <>
                IAF CertSearch has received support from many levels of the
                accredited certification network, industry, government and
                regulators.
              </>
            }
          />
        </div>

        <div className="d-flex justify-content-end mb-3 mb-md-0">
          <SectionContentsCta
            tag={Link}
            outline
            href="/about"
            to="/letters-of-support"
          >
            Read More Support Letters
          </SectionContentsCta>
        </div>
      </SectionContents>

      <Row className="position-relative py-3 py-md-5">
        <Card isMobile={isMobile} />
        <div className={local['white-fade']} />
      </Row>
    </Section>
  );
}
